import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Selecting Fitclub and embracing the perfect plan was my passport to a dream physique. I have already unlocked my ideal body!',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:'In the journey towards fitness, Fitclub and their tailored program was my North Star. Now, my ideal body is a reality!',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
